/**
 * author: Soumya Shreyas
 */
import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Table, Badge, Form, Dropdown, Button, Modal } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import {
  BiDotsHorizontalRounded,
  BiSearch,
  BiSort,
  BiChevronRight,
} from "react-icons/bi";
import moment from "moment";
import { FcFinePrint } from "react-icons/fc";
import { CgSortAz } from "react-icons/cg";
import { toast } from "react-toastify";
import { Typeahead } from "react-bootstrap-typeahead";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Pagination from "../../../components/Pagination/Pagination";
import {
  DEFAULT_ITEMS_PER_PAGE,
  LIST_DEF_SORT,
  SORT_ORDER_DESC,
  FORM_BUILDER_LISTING_URL,
  RISKSTATUS,
} from "../../../core/constants/common";
import UserService from "../../../core/service/UserService";
import { RegulationContext } from "../../../App";
import ErrorHandlingService from "../../../core/service/ErrorHandlingService";
import nodataimg from "../../../images/nodatafound.png";
import Utils from "../../../core/utilities/Utils";

function UserActivities({ t }) {
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);
  const [searchKey, setSearchKey] = useState("");
  const [show, setShow] = useState(false);

  const [userActivities, setUserActivities] = useState([]);
  const [startDate, setStartDate] = useState(new Date());

  const [endDate, setEndDate] = useState(new Date());

  var authToken = localStorage.getItem("accessToken");
  var data = JSON.parse(localStorage.getItem("authority"));
  const navigate = useNavigate();

  useEffect(() => {
    getUserActivities(0, itemsPerPage, searchKey, sortField);
  }, []);

  const handleSort = (val) => {
    if (sortField === val && order === "asc") {
      setOrder("desc");
    } else {
      setOrder("asc");
    }
    setSortField(val);
    getUserActivities(0, itemsPerPage, searchKey, val);
  };
  const handleSearch = (val) => {
    setSearchKey(val);
    getUserActivities(0, itemsPerPage, val, sortField);
  };

  const handleClose = () => {
    setShow(false);
  };

  const getUserActivities = (
    pageNumber,
    itemsPerPageVal,
    searchVal = "",
    sortField
  ) => {
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      var perPage = itemsPerPageVal;
    } else {
      var perPage = itemsPerPage;
    }
    var sort = sortField + "," + order;
    UserService.getUserActivities(pageNumber, perPage, searchVal, sort)
      .then((response) => {
        var totalPages = parseFloat(response.headers["x-total-count"]);
        setItemTotalCount(totalPages);
        setUserActivities([...response.data]);
      })
      .catch((error) => {
        //  console.log("err", error);
      });
  };

  const filterBy = () => true;

  return (
    <>
      <div className="FormsList">
        <div className="List_header">
          <h5 className="MH">{t("ActivityLog.label")}</h5>
        </div>

        <div className="List_Table_01">
          <div className="List_table-card01_head">
            <div className="List_table-card_Search_01">
              <div className="List_table-card_Search_Box">
                <Form>
                  <input
                    type="text"
                    className="form-control"
                    value={searchKey}
                    onChange={(e) => setSearchKey(e.target.value)}
                  />
                  <Link to="#" className="Search_iocnBox">
                    <BiSearch onClick={() => handleSearch(searchKey)} />
                  </Link>
                </Form>
              </div>
            </div>
            <div className="List_table-card01_sort">
              <ul>
                {/* <li>
                    <Link to="#">
                      <BiShareAlt /> {t("Share.label")}
                    </Link>
                  </li> */}
                <li>
                  {" "}
                  <label className="mb-1">{t("FromDate.label")}</label>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    className="form-control"
                    required
                    dateFormat="dd/MM/yyyy"
                  />
                </li>
                <li>
                  <label className="mb-1">{t("ToDate.label")}</label>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    className="form-control"
                    required
                    dateFormat="dd/MM/yyyy"
                  />
                </li>
                <li >
                  <button className="btn btn-primary mt-3">{t("Go.label")}</button>
                </li>
                {/* <li className="filter">
                  <Link to="#">
                    <CgSortAz /> {t("Filter.label")}
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>
          <div className="card List_table-card01">
            <Table responsive="sm">
              <thead>
                <tr>
                  <th className="th_check">
                    <Form.Check
                      inline
                      name="group1"
                      type="checkbox"
                      id="inline-checkbox-1"
                    />
                  </th>
                  <th>
                    <Link to="#" onClick={() => handleSort("lastModifiedDate")}>
                      {t("Date.label")}
                      <BiSort />
                    </Link>
                  </th>
                  <th>{t("Time.label")}</th>

                  <th>
                    <Link to="#" onClick={() => handleSort("userName")}>
                      {t("UserName.label")}
                      <BiSort />
                    </Link>
                  </th>
                  <th>
                    {/* <Link to="#" onClick={() => handleSort("message")}> */}
                    {t("Message.label")}
                    {/* <BiSort /> */}
                    {/* </Link> */}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {userActivities?.length > 0 ? (
                  userActivities?.map((item, index) => (
                    <tr key={item.id}>
                      <td className="checkbox">
                        {" "}
                        <Form.Check
                          inline
                          name="group1"
                          type="checkbox"
                          id="inline-checkbox-1"
                        />
                      </td>
                      <td>
                        {moment(item.lastModifiedDate).format("MMM DD, YYYY")}
                      </td>
                      <td>{moment(item.lastModifiedDate).format("h:mm a")}</td>
                      <td>{item.userName}</td>
                      <td>{Utils.sentenceCase(item.type)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      <div className="Nodatafound_box">
                        <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <div className="p-2 List_footer_count">
              <Pagination
                itemsTotalCount={itemsTotalCount}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                alwaysShown={true}
                setItemsPerPage={setItemsPerPage}
                pageClicked={(pageNum, perPage) => {
                  getUserActivities(pageNum, perPage, searchKey, sortField);
                }}
              />
            </div>
          </div>
        </div>

      </div>
    </>
  );
}
UserActivities.propTypes = {};

export default withTranslation()(UserActivities);
